import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';


/**
 * @title Table retrieving data through HTTP
 */

class Post {
  constructor(
    public userId: number,
    public id: string,
    public title: string,
    public body: string
  ) { }
}



@Component({
  selector: 'app-shopi-auths',
  templateUrl: './shopi-auths.component.html',
  styleUrls: ['./shopi-auths.component.scss']
})



export class ShopiAuthsComponent implements AfterViewInit {
  displayedColumns: string[] = ['number', 'state', 'created'];
  exampleDatabase: ExampleHttpDatabase2 | null;
  data: GithubIssue2[] = [];
  coins;
  la_fecha_corte;
  shop = ""
  redirect_a = ""


  


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(private _httpClient: HttpClient, private _hs: HttpService, private route: ActivatedRoute) { }


  handleClick(event: Event) {
    // console.log('Click!', event);

    // getPosts() {
      const promise = new Promise((resolve, reject) => {
        const apiURL = 'https://vertigofin.herokuapp.com/recibir_shopi_auth?shop=' + this.shop;
        this._httpClient
          .post<Post[]>(apiURL, {})
          .toPromise()
          .then((res: any) => {
            // console.log("entramos en el success")
            // console.log(res)
            // Success
            window.location.href = res.redirect_url
            resolve();
          },
            err => {
              // Error
              reject(err);
            }
          );
      });
      // return promise;
    // }
  }


  ngAfterViewInit() {


    // this.route.paramMap.subscribe((params: ParamMap) => {
    //   let token = params.get('token');
    //   console.log("el token es " + token);
    // });

    let code = this.route.snapshot.queryParamMap.get("code");
    let shop = this.route.snapshot.queryParamMap.get("shop");
    let hmac = this.route.snapshot.queryParamMap.get("hmac");
    let consignor_id = this.route.snapshot.queryParamMap.get("consignor_id");

    if(hmac == null && shop != null){
      // this._hs.enviar_shopiauth(shop, consignor_id)
    }else if(code != null){
      // this._hs.pedir_token(shop, consignor_id, code)
    }
    


    
    this.exampleDatabase = new ExampleHttpDatabase2(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface GithubApi2 {
  items: GithubIssue2[];
  total_count: number;
}

export interface GithubIssue2 {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase2 {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi2> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_shopi_auths.json';
    // console.log(href)
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;
        // console.log("vamnos con la 130")
    // console.log(this._httpClient.get<GithubApi2>(requestUrl))

    return this._httpClient.get<GithubApi2>(requestUrl);
  }
}
